import { useState } from 'react';
import Raven from 'raven-js';
import I18n from 'I18n';
import { getAbsoluteReconnectUrl } from '../../utils/urlUtils';
import { BasicReconnectButton } from '../../components/reconnectButton/BasicReconnectButton';
import { postAuthData } from './eventbriteApi';
import { jsx as _jsx } from "react/jsx-runtime";
const FIVE_MINUTES = 300000;
export const EventbriteReconnectButton = ({
  buttonProps,
  buttonComponent,
  loading: propsLoading,
  failed: propsFailed,
  'data-test-id': dataTestId,
  label,
  metadata,
  onAuthStarted,
  onAuthCancelled,
  onAuthSucceeded,
  timeout = FIVE_MINUTES,
  url
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const accountId = metadata === null || metadata === void 0 ? void 0 : metadata.accountId;
  const authUrl = getAbsoluteReconnectUrl({
    urlTemplate: url,
    appId,
    accountId
  });
  const handleAuthSucceeded = code => {
    setLoading(true);
    postAuthData(code).then(() => {
      setError(null);
      onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(code);
    }).catch(err => {
      Raven.captureException(err, {
        extra: {
          message: 'Error on authentication of Eventbrite'
        }
      });
      setError(err);
      onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
        error: err,
        errorMessage: I18n.text('reconnectionError.commonMessage')
      });
    }).finally(() => {
      setLoading(false);
    });
  };
  const isLoading = propsLoading || loading;
  const isFailed = propsFailed || !!error;
  return authUrl && label ? /*#__PURE__*/_jsx(BasicReconnectButton, {
    buttonProps: buttonProps,
    buttonComponent: buttonComponent,
    loading: isLoading,
    failed: isFailed,
    "data-test-id": dataTestId,
    label: label,
    onAuthStarted: onAuthStarted,
    onAuthCancelled: onAuthCancelled,
    onAuthSucceeded: handleAuthSucceeded,
    timeout: timeout,
    url: authUrl
  }) : null;
};